import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectObjective } from "../Model/ProposalProjectObjective";

export async function patchProposalProjectObjective(data) {	
	let response = await getAPIResponse("/v1/proposal-project-objective", data, "PATCH");
	if (response === null) {
		return null;
	}
	let proposalProjectObjective = ProposalProjectObjective.createFromResponseData(response);
	return proposalProjectObjective;
}